import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Lgpd from '../../../Lgpd';
// import DocumentLink from '../../../DocumentLink/Single';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import FiltroComunicados from '../../../Filtros/FiltroComunicados';
import InfoComponent from '../../InfoComponent';

class PerfilDeInvestimento extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>

					<InfoComponent image={"planoTaesaInvestimento"} page={'planoTaesaInvestimento'}></InfoComponent>

					{/* Content page */}
					<ErrorBoundary><FiltroComunicados url={"/ObterInvestimentoTaesa"} urlFiltro={"/ObterInvestimentoTaesa?"} /></ErrorBoundary>

				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default PerfilDeInvestimento;